export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 登录
     * @param {Object} data 登录携带的信息
     */
    loginByAccountAndPassword: function loginByAccountAndPassword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/mng/user/login/accountAndPassword',
        method: 'post',
        data: data
      });
    },
    refreshToken: function refreshToken() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/mng/user/refresh/token',
        method: 'post',
        params: data
      });
    }
  };
});